import { buildServices } from '@abb/services';
import { getEnvDomain } from 'utils/getEnvDomain';
export const URGENT_CARD_PRICE = 10;
export const SALARY_CARD_PREFIX = '33881';
export const SALARY_CARD_FOREIGN_PREFIX = '33883';
export const INTERNAL_PAYMENT_MAX_FILE_SIZE = 20; //MB
export const MIN_AMOUNT = 0.01;
export const TRANSACTION_TIMINGS = {
    SALARY: {
        startTime: '8:00',
        endTime: '18:00'
    },
    INTERNAL: {
        startTime: '01:00',
        endTime: '17:30'
    },
    EXCHANGE: {
        startTime: '09:00',
        endTime: '18:00'
    },
    INTERNATIONAL: {
        urgent: '16:00'
    }
};
export var CURRENCY = /*#__PURE__*/ function(CURRENCY) {
    CURRENCY["AZN"] = "AZN";
    CURRENCY["EUR"] = "EUR";
    CURRENCY["USD"] = "USD";
    return CURRENCY;
}({});
export const REPEATABLE_DATAS = {
    DICTIONARY: 'dictionary/v1/dictionary',
    INTRO_DARK_MODE: 'intro-dark-mode'
};
export const NLS_LOAD_PATH = {
    deposit: '/mf-deposit/locales/{{lng}}/{{ns}}.json',
    order: '/mf-order/locales/{{lng}}/{{ns}}.json',
    card: '/mf-card/locales/{{lng}}/{{ns}}.json',
    exchange: '/mf-exchange/locales/{{lng}}/{{ns}}.json',
    gpp: '/mf-gpp/locales/{{lng}}/{{ns}}.json',
    reports: '/mf-reports/locales/{{lng}}/{{ns}}.json',
    guarantee: '/mf-guarantee/locales/{{lng}}/{{ns}}.json',
    loan: '/mf-loan/locales/{{lng}}/{{ns}}.json',
    bundle: '/mf-bundle/locales/{{lng}}/{{ns}}.json',
    account_opening: '/mf-account-opening/locales/{{lng}}/{{ns}}.json',
    anipay: '/mf-anipay/locales/{{lng}}/{{ns}}.json',
    accounts: '/mf-account/locales/{{lng}}/{{ns}}.json',
    mail_box: '/mf-mailbox/locales/{{lng}}/{{ns}}.json',
    user_profile: '/mf-profile/locales/{{lng}}/{{ns}}.json',
    payment: '/mf-payment/locales/{{lng}}/{{ns}}.json',
    approvement: '/mf-approval/locales/{{lng}}/{{ns}}.json',
    pos: '/abb-cb-pos-mf/locales/{{lng}}/{{ns}}.json',
    dashboard: '/abb-cb-dashboard-mf/locales/{{lng}}/{{ns}}.json',
    user_info: '/abb-cb-user-info-mf/locales/{{lng}}/{{ns}}.json',
    invest: '/abb-cb-invest-mf/locales/{{lng}}/{{ns}}.json',
    dgk: '/abb-cb-dgk-mf/locales/{{lng}}/{{ns}}.json',
    insurance_card: '/abb-cb-insurance-card-mf/locales/{{lng}}/{{ns}}.json',
    service_card: '/abb-cb-service-card-mf/locales/{{lng}}/{{ns}}.json',
    special_card: '/abb-cb-special-card-mf/locales/{{lng}}/{{ns}}.json',
    special_salary_card: '/abb-cb-special-salary-card-mf/locales/{{lng}}/{{ns}}.json',
    student_card: '/abb-cb-student-card-mf/locales/{{lng}}/{{ns}}.json',
    beyond: '/abb-cb-beyond-banking-mf/locales/{{lng}}/{{ns}}.json',
    tax_assistance: '/abb-cb-tax-assistance-mf/locales/{{lng}}/{{ns}}.json',
    customs_services: '/abb-cb-customs-services-mf/locales/{{lng}}/{{ns}}.json',
    pos_analytics: '/abb-cb-pos-analytics-mf/locales/{{lng}}/{{ns}}.json',
    sms_email_notification: '/abb-cb-sms-email-notification-mf/locales/{{lng}}/{{ns}}.json',
    b2b: '/mf-b2b/locales/{{lng}}/{{ns}}.json',
    mkr: '/abb-cb-mkr-mf/locales/{{lng}}/{{ns}}.json',
    fatca_crs: '/abb-cb-fatca-crs-mf/locales/{{lng}}/{{ns}}.json',
    supply_chain: '/abb-cb-supply-chain-mf/locales/{{lng}}/{{ns}}.json',
    contract_sign: '/abb-cb-contract-sign-mf/locales/{{lng}}/{{ns}}.json',
    swift_inbound_tracking: '/cb-swift-g4c-inbound-tracking-mf/locales/{{lng}}/{{ns}}.json',
    cb_components: '/abb-cb-components-mf/locales/{{lng}}/{{ns}}.json',
    erp: '/abb-cb-erp-mf/locales/{{lng}}/{{ns}}.json',
    ownTransfer: '/abb-cb-own-transfer-mf/locales/{{lng}}/{{ns}}.json',
    marketplace: '/abb-cb-marketplace-mf/locales/{{lng}}/{{ns}}.json',
    internalTransfer: '/abb-cb-internal-transfer-mf/locales/{{lng}}/{{ns}}.json',
    salaryTransfer: '/abb-cb-salary-transfer-mf/locales/{{lng}}/{{ns}}.json'
};
export const SERVICES = buildServices({
    baseURL: getEnvDomain(),
    domain: 'cb'
});
export const whiteListAccountsForSpecialSalary = [
    '12526019447459507204'
];
export const whiteListCifForSpecialSalary = '7459507';
export const customB2BTheme = {
    components: {
        Form: {
            variants: {
                floating: {
                    container: {
                        _focusWithin: {
                            label: {
                                transform: 'scale(0.8) translateY(-13px)',
                                top: '3px'
                            },
                            input: {
                                borderColor: 'inherit',
                                boxShadow: 'none'
                            }
                        },
                        label: {
                            top: '0px',
                            left: '2px',
                            zIndex: 2,
                            position: 'absolute',
                            pointerEvents: 'none',
                            mx: 3,
                            px: 1,
                            my: 4,
                            transformOrigin: 'left top',
                            fontSize: '16px',
                            fontWeight: 400,
                            color: '#0000005C'
                        },
                        input: {
                            height: '56px',
                            fontSize: '16px',
                            borderColor: '#E3E4E8',
                            px: '16px',
                            paddingTop: '14px',
                            borderRadius: '10px',
                            _focusWithin: {
                                borderColor: 'brand.abb.primary'
                            }
                        },
                        'input:not(:placeholder-shown) + label,.chakra-input__group:has(input:not(:placeholder-shown)) + label,.chakra-select__wrapper + label, textarea:not(:placeholder-shown) ~ label': {
                            transform: 'scale(0.8) translateY(-13px)',
                            top: '3px'
                        },
                        'input[aria-invalid=true], input[data-invalid]': {
                            boxShadow: 'none'
                        }
                    }
                }
            }
        }
    }
};
export const DATE_REGEX = /\b\d{2}\.\d{2}\.\d{2}\b/;
export const BOLD_HIGHLIGHT_REGEX = /(\b\d{2}\.\d{2}\.\d{2,4}\b|\b[A-Z0-9]{10,}\b)/gi;
export const REFERENCE_NUMBER_REGEX = /\b\d{3}[A-Z]+[0-9]+\b/;
